/* Bare Kind fixes: live bag count after any cart change, and an always-available Add to bag bar on phones. */
(function(){
  if (window.__bkzFix) return; window.__bkzFix = true;

  /* 1) Keep every bag-count bubble in sync with the real cart */
  var t;
  function syncCount(){
    clearTimeout(t);
    t = setTimeout(function(){
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){
        var n = c.item_count;
        document.querySelectorAll('.cart-count-bubble').forEach(function(b){
          var s = b.querySelector('span[aria-hidden="true"]') || b;
          s.textContent = n;
          var v = b.querySelector('.visually-hidden'); if (v) v.textContent = n + (n === 1 ? ' item' : ' items');
          b.hidden = n === 0; b.style.display = n === 0 ? 'none' : '';
        });
        document.querySelectorAll('.cart__count-bubble span[aria-hidden="true"]').forEach(function(s){ s.textContent = n; });
        nudge(n); setTimeout(function(){ nudge(n); }, 900);
      }).catch(function(){});
    }, 250);
  }
  /* Pack nudge above every checkout button: 3 pairs = 20% off, 5 pairs = 25% off (Shopify automatic discounts BUY3 / BUY5) */
  function nudge(n){
    var msg = n === 0 ? '' : n < 3 ? 'Add ' + (3 - n) + ' more pair' + (3 - n === 1 ? '' : 's') + ' to get 20% off' : n < 5 ? '20% off unlocked! Add ' + (5 - n) + ' more for 25% off' : '25% off unlocked on your pack!';
    var pct = n >= 5 ? 100 : n >= 3 ? 60 + (n - 3) * 20 : n * 20;
    document.querySelectorAll('button[name="checkout"], #checkout, #CartDrawer-Checkout').forEach(function(btn){
      var host = btn.closest('form') || btn.parentElement; if (!host || !host.parentElement) return;
      var el = host.parentElement.querySelector(':scope > .bkz-nudge');
      if (!el){ el = document.createElement('div'); el.className = 'bkz-nudge'; el.setAttribute('role', 'status'); host.parentElement.insertBefore(el, host);
        el.style.cssText = 'margin:0 0 12px;padding:10px 14px;border:2px solid #2D3C37;border-radius:14px;background:#F6F1DE;color:#2D3C37;font:700 14px/1.35 \'Work Sans\',sans-serif;text-align:left'; }
      el.hidden = !msg;
      el.innerHTML = msg ? msg + '<span style="display:block;height:6px;margin-top:8px;border-radius:9px;background:#fff;border:1px solid #2D3C37;overflow:hidden"><span style="display:block;height:100%;width:' + pct + '%;background:#B85A00"></span></span>' : '';
    });
  }
  window.addEventListener('modalOpened', function(){ syncCount(); });
  if (document.readyState !== 'loading') syncCount(); else document.addEventListener('DOMContentLoaded', syncCount);

  var CART = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch) {
    var f0 = window.fetch;
    window.fetch = function(input){
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = f0.apply(this, arguments);
      if (CART.test(u)) p.then(syncCount, syncCount);
      return p;
    };
  }
  var o0 = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){
    if (CART.test(String(u))) this.addEventListener('loadend', syncCount);
    return o0.apply(this, arguments);
  };
  window.addEventListener('pageshow', function(e){ if (e.persisted) syncCount(); });
  document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'visible') syncCount(); });

  /* 2) Phones: show the sticky Add to bag bar whenever the main button is off screen (above or below) */
  function sticky(){
    if (!window.matchMedia('(max-width: 900px)').matches || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-bkz-pdp]').forEach(function(root){
      var atc = root.querySelector('[data-atc]'), st = root.querySelector('[data-sticky]'), btn = root.querySelector('[data-sticky-btn]');
      if (!atc || !st) return;
      new IntersectionObserver(function(en){
        var show = !en[0].isIntersecting;
        st.classList.toggle('z-show', show); st.setAttribute('aria-hidden', show ? 'false' : 'true'); if (btn) btn.tabIndex = show ? 0 : -1;
      }).observe(atc);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(sticky, 0); }); else setTimeout(sticky, 0);

  /* 3) Back-in-stock: show "Notify me" whenever the chosen size is sold out, and tag the signup with that size */
  function notify(){
    document.querySelectorAll('[data-bkz-pdp]').forEach(function(root){
      var box = root.querySelector('[data-notify]'), lbl = root.querySelector('[data-atc-label]'); if (!box || !lbl) return;
      var tags = box.querySelector('[data-notify-tags]');
      if (box.querySelector('[data-notify-ok]')) { box.hidden = false; if (/customer_posted=true/.test(location.search)) box.scrollIntoView({ block: 'center' }); return; }
      function slug(t){ return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
      function update(){
        var soldOut = /sold out/i.test(lbl.textContent); box.hidden = !soldOut;
        if (tags) { var h = tags.getAttribute('data-handle'), size = [].map.call(root.querySelectorAll('input[data-opt]:checked'), function(i){ return i.value; }).join(' ');
          tags.value = 'back-in-stock,bis-' + h + (size ? ',bis-' + h + '-' + slug(size) : ''); }
      }
      new MutationObserver(update).observe(lbl, { childList: true, characterData: true, subtree: true });
      root.addEventListener('change', function(){ setTimeout(update, 0); });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(notify, 0); }); else setTimeout(notify, 0);
})();
